import styled from 'styled-components';

export const Container = styled.div`
  /* TODO: Agregar estilos del header del documento */
`;
